"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigurationByNetwork = exports.isSnapInstalled = exports.isMetamaskSnapsSupported = exports.hasMetaMask = void 0;
function hasMetaMask() {
    if (!window.ethereum) {
        return false;
    }
    return window.ethereum.isMetaMask;
}
exports.hasMetaMask = hasMetaMask;
function getWalletSnaps() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.ethereum.request({
                        method: 'wallet_getSnaps'
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function isMetamaskSnapsSupported() {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getWalletSnaps()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.isMetamaskSnapsSupported = isMetamaskSnapsSupported;
function isSnapInstalled(snapOrigin, version) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, _c, _d, e_2;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = console).log;
                    return [4 /*yield*/, getWalletSnaps()];
                case 1:
                    _b.apply(_a, [_e.sent()]);
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 4, , 5]);
                    _d = (_c = Object).values;
                    return [4 /*yield*/, getWalletSnaps()];
                case 3: return [2 /*return*/, !!_d.apply(_c, [_e.sent()]).find(function (permission) {
                        return permission.id === snapOrigin &&
                            (!version || permission.version === version);
                    })];
                case 4:
                    e_2 = _e.sent();
                    console.log('Failed to obtain installed snaps', e_2);
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.isSnapInstalled = isSnapInstalled;
function getConfigurationByNetwork(network) {
    return {
        mainnet: {
            rpc: {
                node: 'https://fullnode.devnet.aptoslabs.com',
                faucet: 'https://faucet.devnet.aptoslabs.com/'
            }
        },
        devnet: {
            rpc: {
                node: 'https://fullnode.devnet.aptoslabs.com',
                faucet: 'https://faucet.devnet.aptoslabs.com/'
            }
        },
        testnet: {
            rpc: {
                node: 'https://fullnode.testnet.aptoslabs.com',
                faucet: 'https://faucet.testnet.aptoslabs.com/'
            }
        }
    }[network];
}
exports.getConfigurationByNetwork = getConfigurationByNetwork;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBRUEsU0FBZ0IsV0FBVztJQUN6QixJQUFJLENBQUMsTUFBTSxDQUFDLFFBQVEsRUFBRTtRQUNwQixPQUFPLEtBQUssQ0FBQTtLQUNiO0lBQ0QsT0FBTyxNQUFNLENBQUMsUUFBUSxDQUFDLFVBQVUsQ0FBQTtBQUNuQyxDQUFDO0FBTEQsa0NBS0M7QUFVRCxTQUFlLGNBQWM7Ozs7d0JBQ3BCLHFCQUFNLE1BQU0sQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDO3dCQUNuQyxNQUFNLEVBQUUsaUJBQWlCO3FCQUMxQixDQUFDLEVBQUE7d0JBRkYsc0JBQU8sU0FFTCxFQUFBOzs7O0NBQ0g7QUFFRCxTQUFzQix3QkFBd0I7Ozs7Ozs7b0JBRTFDLHFCQUFNLGNBQWMsRUFBRSxFQUFBOztvQkFBdEIsU0FBc0IsQ0FBQTtvQkFDdEIsc0JBQU8sSUFBSSxFQUFBOzs7b0JBRVgsc0JBQU8sS0FBSyxFQUFBOzs7OztDQUVmO0FBUEQsNERBT0M7QUFFRCxTQUFzQixlQUFlLENBQ25DLFVBQWtCLEVBQ2xCLE9BQWdCOzs7Ozs7b0JBRWhCLEtBQUEsQ0FBQSxLQUFBLE9BQU8sQ0FBQSxDQUFDLEdBQUcsQ0FBQTtvQkFBQyxxQkFBTSxjQUFjLEVBQUUsRUFBQTs7b0JBQWxDLGNBQVksU0FBc0IsRUFBQyxDQUFBOzs7O29CQUV4QixLQUFBLENBQUEsS0FBQSxNQUFNLENBQUEsQ0FBQyxNQUFNLENBQUE7b0JBQUMscUJBQU0sY0FBYyxFQUFFLEVBQUE7d0JBQTdDLHNCQUFPLENBQUMsQ0FBQyxjQUFjLFNBQXNCLEVBQUMsQ0FBQyxJQUFJLENBQ2pELFVBQUMsVUFBVTt3QkFDVCxPQUFBLFVBQVUsQ0FBQyxFQUFFLEtBQUssVUFBVTs0QkFDNUIsQ0FBQyxDQUFDLE9BQU8sSUFBSSxVQUFVLENBQUMsT0FBTyxLQUFLLE9BQU8sQ0FBQztvQkFENUMsQ0FDNEMsQ0FDL0MsRUFBQTs7O29CQUVELE9BQU8sQ0FBQyxHQUFHLENBQUMsa0NBQWtDLEVBQUUsR0FBQyxDQUFDLENBQUE7b0JBQ2xELHNCQUFPLEtBQUssRUFBQTs7Ozs7Q0FFZjtBQWZELDBDQWVDO0FBRUQsU0FBZ0IseUJBQXlCLENBQUUsT0FBcUI7SUFDOUQsT0FBTztRQUNMLE9BQU8sRUFBRTtZQUNQLEdBQUcsRUFBRTtnQkFDSCxJQUFJLEVBQUUsdUNBQXVDO2dCQUM3QyxNQUFNLEVBQUUsc0NBQXNDO2FBQy9DO1NBQ0Y7UUFDRCxNQUFNLEVBQUU7WUFDTixHQUFHLEVBQUU7Z0JBQ0gsSUFBSSxFQUFFLHVDQUF1QztnQkFDN0MsTUFBTSxFQUFFLHNDQUFzQzthQUMvQztTQUNGO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsR0FBRyxFQUFFO2dCQUNILElBQUksRUFBRSx3Q0FBd0M7Z0JBQzlDLE1BQU0sRUFBRSx1Q0FBdUM7YUFDaEQ7U0FDRjtLQUNGLENBQUMsT0FBTyxDQUFDLENBQUE7QUFDWixDQUFDO0FBckJELDhEQXFCQyJ9